export default __webpack_public_path__ + "static/media/step_B_EN.04157499.png";